<template>
  <div>
    <vTableEditable
      v-if="isAdmin"
      :table="table"
      :items="newItems"
      :headersProp="headers"
      :title="title"
      :foreignTablesArray="foreignTablesArray"
      :foreignKeysArray="foreignKeysArray"
      :items-per-page="itemsPerPage"
      @field-updated="fieldUpdated"
      @selection-made="emitItemsSelected"
      @item-deleted="itemDeleted"
    ></vTableEditable>
    <vTable
      v-else
      :table="table"
      :items="newItems"
      :headers="headers"
      :title="title"
      :items-per-page="itemsPerPage"
    ></vTable>
  </div>
</template>

<script>
import vTable from "../Legos/vTable.vue";
import vTableEditable from "../Legos/vTableEditable.vue";

export default {
  watch: {
    items(newVal) {
      this.newItems = [];
      this.newItems = newVal;
    },
  },
  mounted() {
    this.newItems = this.items;
  },
  props: {
    table: {
      default: null,
    },
    headers: {
      default: [],
    },
    items: {
      default: [],
    },
    title: {
      default: null,
    },
    foreignTablesArray: {
      default: () => [],
    },
    foreignKeysArray: {
      default: () => [],
    },
    itemsPerPage: {
      default: 10,
    },
  },
  computed: {
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
  },
  components: { vTable, vTableEditable },
  data: () => ({
    newItems: [],
  }),
  methods: {
    emitItemsSelected(selectedItems) {
      this.$emit("items-selected", selectedItems);
    },
    fieldUpdated(arr) {
      this.$emit("input-field-updated", arr);
    },
    itemDeleted(selectedObjsArrayOrID) {
      this.$emit("item-deleted", selectedObjsArrayOrID);
    },
  },
};
</script>

<style></style>
